import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  container: {
    maxWidth: '70%',
    minWidth: 260,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'center',
    marginBottom: 16,
    backgroundColor: theme.palette.background.default,
    borderRadius: 16,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#C4C6C9',
  },
  startDateContainer: {
    display: 'flex',
    width: '50%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  endDateContainer: {
    display: 'flex',
    width: '50%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  datePicker: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.background.default,
    height: 24,
    fontSize: 8,
    elevation: 8,
    marginLeft: 8,
    marginRight: 8,
    '&:active': {
      outline: 'none',
    },
    '&:focus': {
      outline: 'none',
    },
    '& input': {
      textAlign: 'center',
      fontSize: 10,
      fontWeight: 'bold',
    },
    '& input::placeholder': {
      color: '#000000',
      fontWeight: 500,
      fontSize: 10,
      textAlign: 'center',
    },
  },
}));
